module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figF04_fourier-transformed-composite-deviations.8f6600d9.png";